module.exports = require('./helpers/bundle-url').getBundleURL('8yBhy') + "logo-dark.eefe0b7f.svg";